import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=a82e3f56&scoped=true&"
import script from "./Money.vue?vue&type=script&lang=ts&"
export * from "./Money.vue?vue&type=script&lang=ts&"
import style0 from "./Money.vue?vue&type=style&index=0&id=a82e3f56&prod&lang=scss&"
import style1 from "./Money.vue?vue&type=style&index=1&id=a82e3f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82e3f56",
  null
  
)

export default component.exports